<template>
  <div class="image-inputs">
    <InterviewAnswerImage
        v-for="(image, index) in images"

        :key="index"
        :disabled="disabled"

        v-model="images[index]"

        @addedImage="addImage()"
        @deleteImage="deleteImage(index)"
    />
  </div>
</template>

<script>
import InterviewAnswerImage from './InterviewAnswerImage';
import modal from './../services/modal';

export default {
  components: {
    InterviewAnswerImage,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },

    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      images: null,
    };
  },

  created() {
    this.images = this.value;

    this.addImage();
  },

  watch: {
    value() {
      this.images = this.value;

      if (this.value && typeof this.value === 'object' && !this.value.length) {
        this.addImage();
      }
    }
  },

  methods: {
    deleteImage(index) {
      modal
        .confirmation({
          text: 'Are you sure you would like to remove the image?'
        })
        .then((response) => {
          if (!response.value) return;

          this.images.splice(index, 1);
        });
    },

    addImage() {
      if (this.disabled || this.images.length >= 5) return;

      this.images.push({});
    }
  },
};
</script>

<style scoped>

</style>
